import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import "@/App.css";
import HomePage from "@/pages/HomePage";
import PlatformPage from "@/pages/PlatformPage";
import SolutionsHubPage from "@/pages/SolutionsHubPage";
import IndustriesPage from "@/pages/IndustriesPage";
import AIBrainPage from "@/pages/AIBrainPage";
import RewardsPage from "@/pages/RewardsPage";
import IntegrationsPage from "@/pages/IntegrationsPage";
import ContactPage from "@/pages/ContactPage";
import PrivacyPolicyPage from "@/pages/PrivacyPolicyPage";
import TermsOfUsePage from "@/pages/TermsOfUsePage";
import CookiePolicyPage from "@/pages/CookiePolicyPage";
import SecurityCompliancePage from "@/pages/SecurityCompliancePage";
import { BlogListPage, BlogPostPage } from "@/pages/BlogPage";
import ResourcesPage from "@/pages/ResourcesPage";
import { PressListPage, PressDetailPage } from "@/pages/PressPage";
import SEOPage from "@/pages/SEOPage";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import CaseStudiesPage from "@/pages/CaseStudiesPage";
import PartnerPage from "@/pages/PartnerPage";
import ChannelLoyaltyReportPage from "@/pages/ChannelLoyaltyReportPage";
import WhyChannelLoyaltyPage from "@/pages/WhyChannelLoyaltyPage";
import GlossaryPage from "@/pages/GlossaryPage";
import LinkedInPreview from "@/pages/LinkedInPreview";
import MoviePage from "@/pages/MoviePage";
import ScrollToTop from "@/components/ScrollToTop";
import { Toaster } from "@/components/ui/sonner";

function App() {
  return (
    <HelmetProvider>
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          {/* Main Pages */}
          <Route path="/" element={<HomePage />} />
          <Route path="/movie" element={<MoviePage />} />
          <Route path="/platform" element={<PlatformPage />} />
          <Route path="/solutions" element={<SolutionsHubPage />} />
          <Route path="/solutions/:slug" element={<SEOPage />} />
          <Route path="/industries" element={<IndustriesPage />} />
          <Route path="/ai-brain" element={<AIBrainPage />} />
          <Route path="/rewards" element={<RewardsPage />} />
          <Route path="/integrations" element={<IntegrationsPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/case-studies" element={<CaseStudiesPage />} />
          <Route path="/partners" element={<PartnerPage />} />
          <Route path="/channel-loyalty-report-2026" element={<ChannelLoyaltyReportPage />} />
          <Route path="/why-channelloyalty" element={<WhyChannelLoyaltyPage />} />
          <Route path="/glossary" element={<GlossaryPage />} />
          
          {/* Blog & Resources */}
          <Route path="/blog" element={<BlogListPage />} />
          <Route path="/blog/:slug" element={<BlogPostPage />} />
          <Route path="/resources" element={<ResourcesPage />} />
          <Route path="/press" element={<PressListPage />} />
          <Route path="/press/:slug" element={<PressDetailPage />} />
          
          {/* Legal Pages */}
          <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
          <Route path="/terms-of-use" element={<TermsOfUsePage />} />
          <Route path="/cookie-policy" element={<CookiePolicyPage />} />
          <Route path="/security-compliance" element={<SecurityCompliancePage />} />
          
          {/* Admin */}
          <Route path="/admin" element={<AdminLogin />} />
          <Route path="/admin/dashboard" element={<AdminDashboard />} />
          <Route path="/admin/linkedin-preview" element={<LinkedInPreview />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" />
    </div>
    </HelmetProvider>
  );
}

export default App;
